import { CheckCircle, Snackbar, SnackbarText } from "common-ui-components"
import PropTypes from "prop-types";

const Toast = ({ open, text, type, onChange }) => {
  return (
    <Snackbar
      open={open}
      type={type}
      onChange={onChange}
    >
      <SnackbarText>
        <CheckCircle size={21} marginRight />
        {text}
      </SnackbarText>
    </Snackbar>
  )
}

export default Toast;

Toast.propTypes = {
  open: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};